module.exports = __webpack_public_path__ + "calculator/cummins-generator-calculator/static/media/pc.fe6d078c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/images/products/pc.png
// module id = 818
// module chunks = 0